<div class="dialog">
    <h2 class="dialog__title">Change destination / City</h2>

    <p class="dialog__description">
      Remove <b>{{ data.name }}</b> and replace with:
    </p>

    <ul class="destinations-list">
        @if (data.altDestinations; as destinations) {
            @for (dest of destinations; track $index) {
                <li class="destinations-list__item">
                    <div class="radio-btn-box">
                        <input
                            [id]="dest.id"
                            type="radio"
                            name="radio-group"
                            class="radio-btn-box__input"
                            [value]="dest"
                            (ngModelChange)="selectedDestinationRadio = -2"
                            [(ngModel)]="newDestination"
                        />
                        <span class="radio-btn-box__checkmark"></span>
                    </div>
                    <label class="item-label" [for]="dest.id">
                        <span class="item-label__new-dest">
                            {{ dest.cityName }}, {{ dest.countryName }}
                        </span>
                    </label>
                </li>
            }
        }
        <li class="destinations-list__item">
            <div class="radio-btn-box">
                <input
                    id="custom"
                    type="radio"
                    name="radio-group"
                    class="radio-btn-box__input"
                    [checked]="selectedDestinationRadio === 1"
                    (click)="selectCustomDestination()"
                />
                <span class="radio-btn-box__checkmark"></span>
            </div>
            <label class="item-label item-label--full" for="custom">
              <div class="dialog__input-group">
                <input [formControl]="searchForm"
                       [matAutocomplete]="auto"
                       class="dialog__input"
                       placeholder="Type destination/city name"
                />
                <mat-autocomplete #auto="matAutocomplete">
                  @for (option of filteredOptions; track $index) {
                    <mat-option [value]="option.label" (click)="selectedDestinationHandler(option)">
                      {{ option.label }}
                    </mat-option>
                  }
                </mat-autocomplete>
              </div>
            </label>
        </li>
    </ul>

    <div class="dialog__actions">
        <button class="dialog__button dialog__button--cancel" (click)="dialogRef.close(false)">
            Cancel
        </button>
        <button class="dialog__button dialog__button--confirm" (click)="submitBtnHandler()" [disabled]="!newDestination">
            Change destination
        </button>
    </div>
</div>
